import { Outlet, Navigate } from 'react-router-dom';
import { Box, Paper, Container, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export default function AuthLayout() {
  const { isAuthenticated } = useAuth();

  // Redirect to dashboard if already authenticated
  if (isAuthenticated) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            borderRadius: 2,
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: 10
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 700, color: 'primary.main', mb: 3 }}
          >
            Sign in to Preiser
          </Typography>
          <Outlet />
        </Paper>
      </Container>
    </Box>
  );
}
